export default function (state = [], action) {
    switch (action.type) {
        case "ORIENTATION_SELECTED":
            return action.payload;
        default:
            return state;
    }
}